import React, {memo} from "react";
import {useTranslation} from "react-i18next";
import {useField, useFormikContext} from "formik";
import cn from "classnames";
import {SignContractMemberAutocomplete} from "./SignContractMemberAutocomplete";
import {formatCityAscii} from "helpers/helper";

const CompanyAutocompleteField = memo(
  ({
    name,
    label,
    placeholder,
    target,
    addClass,
    onSelectOrganization,
    searchOrganizations,
  }) => {
    const {t} = useTranslation();
    const [field, meta, helpers] = useField(name);
    const {setFieldValue} = useFormikContext();

    const handleSelect = async (selectedItem) => {
      setFieldValue("counterpartyCompanyName", selectedItem.Company?.companyName);
      setFieldValue("counterpartyCompanyNumber", selectedItem.Company?.companyNumber);
      if (selectedItem.Company?.extraData) {
        const extraData = selectedItem.Company?.extraData;
        setFieldValue("counterpartyCompanyAddressMain", extraData?.address1 || "");
        setFieldValue("counterpartyCompanyAddressExtra", extraData?.address2 || "");
        setFieldValue("counterpartyCompanyAddressPostalCode", extraData?.zip || "");
        setFieldValue("counterpartyCompanyAddressCity", formatCityAscii(extraData?.city) || "");
      }
      if (onSelectOrganization && selectedItem?.id) {
        setFieldValue("counterpartyContactFullName", "");
        setFieldValue("counterpartyContactMobilePhone", "");
        setFieldValue("counterpartyContactEmail", "");
        onSelectOrganization(selectedItem.id);
      }
    };

    return (
      <div
        className={cn(
          "form-field_wrapper",
          "__tiny",
          "__bold",
          "__flat-view",
          addClass ?? "mb-1"
        )}
      >
        {label && <label className="__uppercase __bold">{t(label)}</label>}
        <SignContractMemberAutocomplete
          search={searchOrganizations}
          value={field.value}
          onChange={helpers.setValue}
          onSelect={handleSelect}
          onBlur={() => helpers.setTouched(true)}
          target={target}
          placeholder={placeholder}
        />
        {meta.touched && meta.error && <p className="form-error">{t(meta.error)}</p>}
      </div>
    );
  }
);

export {CompanyAutocompleteField};
